import * as React from "react";
import {
  Select,
  Card,
  FormControl,
  Box,
  MenuItem,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useAuth } from "../../context/API_Client";

export default function Dropdown({
  width,
  options,
  theme,
  updateTheme,
  dropDownId,
  def,
}) {
  const [data, setData] = useState(def);

  const handleChange = (event) => {
    setData(event.target.value);
    updateTheme(dropDownId, event.target.value);
  };

  return (
    <Card
      variant="outlined"
      sx={{
        width: { width },
        height: 36,
        alignItems: "center",
        display: "flex",
      }}
    >
      <FormControl>
        <Select
          onChange={handleChange}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={data}
          label="Data"
          sx={{
            boxShadow: "none",
            ".MuiOutlinedInput-notchedOutline": { border: 0 },
            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
              border: 0,
            },
            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
            width: { width },
            height: 36,
            fontSize: "14px",
            fontWeight: "400",
            opacity: "0.85",
            padding: "none",
          }}
        >
          {options.map((val) => (
            <MenuItem
              value={val}
              sx={{
                fontSize: "14px",
                fontWeight: "400",
                opacity: "0.85",
              }}
            >
              {val.charAt(0).toUpperCase() + val.slice(1).toLowerCase()}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Card>
  );
}
